var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 12C1.25 6.086 6.086 1.25 12 1.25S22.75 6.086 22.75 12 17.914 22.75 12 22.75 1.25 17.914 1.25 12ZM12 2.75c-5.086 0-9.25 4.164-9.25 9.25s4.164 9.25 9.25 9.25 9.25-4.164 9.25-9.25S17.086 2.75 12 2.75Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.738 12.166-.005.003c-.29.192-.504.364-.644.55-.148.199-.204.402-.204.633v.295c0 .443-.389.83-.876.83s-.876-.387-.876-.83v-.295c0-1.469 1.096-2.21 1.6-2.55l.001-.001c.282-.185.492-.349.63-.527a.953.953 0 0 0 .203-.614c0-.835-.71-1.502-1.558-1.502-.846 0-1.558.652-1.558 1.502 0 .443-.389.829-.876.829s-.876-.386-.876-.83c0-1.734 1.474-3.159 3.31-3.159s3.31 1.425 3.31 3.16c0 1.47-1.114 2.212-1.581 2.506Z",
    fill: "#123862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.008 17.466a.882.882 0 1 1-.002-1.77.882.882 0 0 1 .002 1.77Z",
    fill: "#123862"
  })));
};
export default SvgQuestionMark;